// Public header (logged-out) — mobile drawer, mobile accordion, desktop dropdown toggle.

(function () {
  const burger   = document.getElementById('burger-btn');
  const drawer   = document.getElementById('mobile-drawer');
  const backdrop = document.getElementById('mobile-backdrop');
  const closeBtn = document.getElementById('close-drawer');

  if (!burger || !drawer || !backdrop || !closeBtn) return;

  function openDrawer() {
    drawer.classList.remove('translate-x-full');
    drawer.classList.add('translate-x-0');
    backdrop.classList.remove('hidden');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.add('translate-x-full');
    drawer.classList.remove('translate-x-0');
    backdrop.classList.add('hidden');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !backdrop.classList.contains('hidden')) closeDrawer();
  });
})();

(function () {
  document.querySelectorAll('[data-mobile-accordion]').forEach(function (acc) {
    const trigger = acc.querySelector('[data-accordion-trigger]');
    const panel   = acc.querySelector('[data-accordion-panel]');
    const caret   = acc.querySelector('[data-accordion-caret]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      const isOpen = !panel.classList.contains('hidden');
      if (isOpen) {
        panel.classList.add('hidden');
        panel.classList.remove('flex');
        trigger.setAttribute('aria-expanded', 'false');
        if (caret) caret.classList.remove('rotate-180');
      } else {
        panel.classList.remove('hidden');
        panel.classList.add('flex');
        trigger.setAttribute('aria-expanded', 'true');
        if (caret) caret.classList.add('rotate-180');
      }
    });
  });
})();

(function () {
  const submenus = document.querySelectorAll('[data-submenu]');
  if (!submenus.length) return;

  submenus.forEach(function (item) {
    const trigger = item.querySelector('[data-submenu-trigger]');
    const panel   = item.querySelector('[data-submenu-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-submenu-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });

      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.classList.toggle('opacity-100', !isOpen);
      panel.classList.toggle('visible', !isOpen);
      panel.classList.toggle('translate-y-0', !isOpen);
      panel.classList.toggle('opacity-0', isOpen);
      panel.classList.toggle('invisible', isOpen);
      panel.classList.toggle('translate-y-1', isOpen);
    });
  });

  document.addEventListener('click', function (e) {
    submenus.forEach(function (item) {
      if (!item.contains(e.target)) {
        const trigger = item.querySelector('[data-submenu-trigger]');
        const panel   = item.querySelector('[data-submenu-panel]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('opacity-100', 'visible', 'translate-y-0');
        panel.classList.add('opacity-0', 'invisible', 'translate-y-1');
      }
    });
  });
})();
